import React from 'react';
import './ServicesHero.scss';
import SectionPlain from '../../components/SectionPlain';
import ServicesCard from '../../components/cards/ServicesCard';

const ServicesHero = ({ title, subTitle, body, services }) => (
  <SectionPlain className="services-hero" subTitle={subTitle} title={title} body={body}>
    <div className="services__cards-container services-hero__cards">
      {services.map((card) => (
        <ServicesCard
          image={card.imageContainer.image.publicURL}
          altText={card.imageContainer.altText}
          title={card.title}
          description={card.description}
          key={card.title}
        />
      ))}
    </div>
  </SectionPlain>
);

export default ServicesHero;
